import Box from '@mui/material/Box';

const DisabledProjectOverlay = () => {
  return <Box position="absolute" zIndex={99} width="100%" height="100%" />;
};

export default DisabledProjectOverlay;
